// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__31zak","title":"Header_title__o7qHW","left":"Header_left__1oh9K","clinicName":"Header_clinicName__kPjau"};